import React from 'react'
import Layout from '../../../component/layout/Layout'
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ParticleSizeAnalyser = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
    };

    // 🔥 Replace with actual images
    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2FResearchDevelopment%2Fimg%2Fplus.png?alt=media&token=227306db-a185-4121-b861-105eac9754c5',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2FResearchDevelopment%2Fimg%2Fplus.png?alt=media&token=227306db-a185-4121-b861-105eac9754c5'
    ];
     
    return (
        <Layout>
            {/* BREADCRUMB */}
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/">Bio-Engineering Instruments</a></li>
                </ul>
            </div>

            {/* TITLE */}
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>AMERIGO /AMERIGO PLUS </h1>
                </div>
            </div>

            {/* MAIN SECTION */}
            <section
                id="portfolio-details"
                className="portfolio-details"
                style={{ backgroundColor: 'white', marginBottom: '12rem' }}
            >
                <div className="container">
                    <div className="row gy-4">

                        {/* IMAGE SLIDER */}
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ textAlign: 'center' }}>
                                                <img
                                                    src={src}
                                                    alt="Labscale Model"
                                                    className="responsive"
                                                    style={{ maxHeight: '400px', objectFit: 'contain' }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>

                        {/* DESCRIPTION */}
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>AMERIGO /AMERIGO PLUS </h3>

                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    <ul>
                                        <li>AMERIGO, the 3-in-1 innovative particle size and zeta potential analyzer, offers unparalleled precision and efficiency</li>
                                        <li>Laser Doppler Electrophoresis (LDE) for zeta potential
                                        </li>
                                        <li>Oxidation-free electrodes for use in any solvent</li>
                                        <li>Measurement principle: Dynamic Light Scattering (DLS)</li>
                                        <li>Scattering angle: 2 angles (17° and 90° or 17° and 170°), 3 angles (17° , 90° and 170°)</li>
                                        <li>Particle size range 1 nm up to 100 μm</li>
                                        <li>Molecular weight range: 0.9 kDa – 20 MDa ±5%</li>
                                        <li>Software: AmeriQTM</li>
                                        <li>Key measurements: Molecular weight, Zeta Potential, Particle size</li>
                                    </ul>

                                    <br />

                                    <a
                                        href="https://cordouan-tech.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            color: '#0d6efd',
                                            fontWeight: '600',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <br />
        </Layout>
    )
}

export default ParticleSizeAnalyser